const FEATURE_HELP_URLS = {
  agent_bots: 'https://chatips.com/archives/21-agent-bots/',
  agents: 'https://chatips.com/archives/13-agents/',
  audit_logs: 'https://chatips.com/archives/29-audit-logs/',
  campaigns: 'https://chatips.com/archives/6-companies/',
  canned_responses: 'https://chatips.com/archives/20-canned-responses-and-templates/',
  channel_email: 'https://chatips.com/archives/12-channels-and-inboxes/',
  channel_facebook: 'https://chatips.com/archives/12-channels-and-inboxes/',
  custom_attributes: 'https://chatips.com/archives/17-custom-attributes/',
  dashboard_apps: 'https://chatips.com/archives/25-integrations/',
  help_center: 'https://chatips.com/archives/8-help-centre/',
  inboxes: 'https://chatips.com/archives/12-channels-and-inboxes/',
  integrations: 'https://chatips.com/archives/25-integrations/',
  labels: 'https://chatips.com/archives/16-labels/',
  macros: 'https://chatips.com/archives/19-macros/',
  reports: 'https://chatips.com/archives/10-reports/',
  sla: 'https://chatips.com/archives/23-sla/',
  team_management: 'https://chatips.com/archives/14-teams/',
  webhook: 'https://chatips.com/archives/25-integrations/',
  billing: 'https://chatips.com/archives/26-billing-and-usage',
  saml: 'https://chatips.com/archives/27-account-settings-and-security/',
  captain: 'https://chatips.com/archives/7-captain-assistant/',
  captain_billing: 'https://chatips.com/archives/26-billing-and-usage/',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
